import { HttpInterceptorFn } from '@angular/common/http';
import {CTX_ATTACH_CUSTOM_HEADERS} from "../../models/api-context-const";
import {environment} from "../../environments/environment";

export const customHeadersInterceptor: HttpInterceptorFn = (req, next) => {
    if (!req.context.get(CTX_ATTACH_CUSTOM_HEADERS)) return next(req);

    const apiOrigin = new URL(environment.baseUrl).origin;
    const isApi = req.url.startsWith(`${apiOrigin}/api`);

    if (!isApi) return next(req);
    const isFormData = req.body instanceof FormData;
    if (isFormData) return next(req);
    const cloned = req.clone({
        setHeaders: {
            ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
            'Accept': 'application/json',
        },
    })

    return next(cloned);
};
